import firestoreServices from '../services/firestore.service';

const insurersFirestoreServices = firestoreServices('insurers');

export default {
  ...insurersFirestoreServices
};
